import {uid, Cookies, LocalStorage, SessionStorage} from 'quasar'
import { posthog } from 'boot/posthog';
import {txu_no_show_zip_codes} from "src/composables/data/txu_no_show_zip_codes";
import {txu_show_zip_codes} from "src/composables/data/txu_show_zip_codes";

// Tag Manager limits
// https://support.google.com/analytics/answer/9267744?hl=en

const get_cid = function () {
  // We need a unique identifier for this session
  // We store it in a localStorage, but you may use cookies, too

  let local_cid = LocalStorage.getItem('cid');

  if (!local_cid) {
    const cid = uid();
    const epoch = Math.round(new Date().getTime() / 1000)
    local_cid = `${ cid }.${ epoch }`
    LocalStorage.set('cid', local_cid);
  }

  Cookies.set('cp_cid', local_cid, { secure: true, domain: 'comparepower.com', sameSite: 'Lax', path: '/', expires: 180 });

  return local_cid;
}

const log_event = function ({ name, keep_name, ...rest }) {
  let service_zip_code = SessionStorage.getItem('zip_code');
  let txu_shown_experience = null;
  if(service_zip_code) {
    if (txu_no_show_zip_codes.includes(service_zip_code)) {
      txu_shown_experience = false;
    } else if (txu_show_zip_codes.includes(service_zip_code)) {
      txu_shown_experience = true;
    }
  }

  if (rest) {
    const value = {};
    for (const key of Object.keys(rest)) {
      value[key] = null;
    }
    dataLayer.push({ event: 'clear', ...value })
  }
  if (rest.cp_cart) {
    rest.cp_cart.user_details.cp_fpid = LocalStorage.getItem('cp_fpid')
    if (rest.cp_cart.user_details.cp_fpid) {
      rest.cp_cart.user_details.cp_fpid_only = rest.cp_cart.user_details.cp_fpid.split('.')[0]
      rest.cp_cart.user_details.cp_fpid_timestamp = rest.cp_cart.user_details.cp_fpid.split('.')[1]
    }
  }
  dataLayer.push({
    event: keep_name ? name : `cp_${ name }`,
    service_zip_code,
    is_txu_split_test_on : posthog.isFeatureEnabled('enable_txu_brand_test'),
    txu_shown_experience,
    cid: get_cid(),
    cp_fpid: LocalStorage.getItem('cp_fpid'),
    ...rest
  });
}

const log_page = function ({ name, path }) {
  dataLayer.push({
    event: `cp_pv_${ name }`,
    path: path,
    cid: get_cid()
  });
}

export default () => {

  return {
    get_cid,
    log_event,
    log_page
  }

}
